import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { AxiosError } from 'axios';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { createDagApi } from '@/entities/dag/api/createDagApi';
import type { CreateDagRequest, DagApiError } from '@/entities/dag/domain/types';

export const useCreateDagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<DagApiError>, CreateDagRequest>({
    mutationFn: (request) => createDagApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });
      message.success(NOTIFICATION_MESSAGES.DAG_CREATE_SUCCESS_DESC);
    },
    onError: (error: AxiosError<DagApiError>) => {
      const errorMessage = error.response?.data?.message ?? NOTIFICATION_MESSAGES.DAG_CREATE_ERROR_DESC;
      message.error(errorMessage);
    },
  });
};
